<template>
  <div>
    <v-card-text>
      <v-sheet outlined class="ma-n2 pa-6">
        <v-row>
          <v-col cols="6" md="4">
            <label>موضوع درخواست: </label>
            <strong>
              {{ tradeRequestDisplayName(tradeRequestItem.request) }}</strong
            >
          </v-col>
          <v-col cols="6" md="4">
            <label>نوع درخواست: </label>
            <strong>
              {{ tradeCategoryDisplayName(tradeRequestItem.category) }}</strong
            >
          </v-col>
          <v-col cols="6" md="4">
            <label>
              مهلت شرکت در
              {{ tradeRequestDisplayName(tradeRequestItem.request) }}
              :
            </label>
            <strong
              >{{ tradeRequestItem.bidExpirationTimeInDays }} روز ({{
                tradeRequestItem.bidExpirationTimeInDaysFromNow != 0
                  ? tradeRequestItem.bidExpirationTimeInDaysFromNow +
                    'روز باقی مانده'
                  : 'منقضی شده'
              }})</strong
            >
          </v-col>
          <v-col cols="6" md="4">
            <label> نام کسب و کار: </label>
            <strong>{{ tradeRequestItem.merchantName }}</strong>
          </v-col>
          <v-col
            cols="6"
            md="4"
            v-if="tradeRequestItem.request != 'ContractorRecognition'"
          >
            <label> روش پرداخت:</label>
            <strong
              >{{ paymentMethodDisplayName(tradeRequestItem.paymentMethod) }}
            </strong>
          </v-col>
          <v-col cols="6" md="4" v-else>
            <label> نحوه تضمین :</label>
            <strong>
              {{ guaranteeMethodDisplayName(tradeRequestItem.guarantee) }}
            </strong>
          </v-col>

          <v-col cols="6" md="4">
            <label> تاریخ ایجاد:</label>
            <strong>{{ jalaliDate(tradeRequestItem.createdTimeUtc) }}</strong>
          </v-col>
          <v-col cols="12">
            <label v-if="tradeRequestItem.request == 'ContractorRecognition'">
              عنوان :</label
            >
            <label v-if="tradeRequestItem.request != 'ContractorRecognition'">
              شرح سفارش :</label
            >
            <strong>{{
              tradeRequestItem.content ? tradeRequestItem.content : 'وارد نشده'
            }}</strong>
          </v-col>
          <v-col
            cols="12"
            v-if="tradeRequestItem.request == 'ContractorRecognition'"
          >
            <label> شرح پروژه/طرح :</label>
            <strong>{{
              tradeRequestItem.orderDescription
                ? tradeRequestItem.orderDescription
                : 'وارد نشده'
            }}</strong>
          </v-col>
          <v-col cols="6" md="4">
            <label> نام و شماره موبایل مسئول:</label>
            <strong
              >{{ tradeRequestItem.ownerName }} -
              {{ tradeRequestItem.ownerPhoneNumber }}</strong
            >
          </v-col>
          <v-col cols="12" v-if="!limitationEditMode">
            <label>محدودیت مکانی : </label>
            <strong>
              {{
                tradeRequestItem.limitation == null
                  ? 'ندارد'
                  : tradeRequestItem.limitation == 'State'
                  ? 'استانی'
                  : tradeRequestItem.limitation == 'City'
                  ? 'شهری'
                  : ''
              }}
            </strong>
            <div v-if="tradeRequestItem.limitation == 'State'">
              <label> لیست استان ها : </label>
              <strong v-for="state in stateName" :key="state">
                {{ state }} ،
              </strong>
            </div>
            <div v-else-if="tradeRequestItem.limitation == 'City'">
              <v-col cols="12">
                <label> لیست استان ها : </label>
                <strong v-for="state in stateName" :key="state">
                  {{ state }}،
                </strong>
              </v-col>
              <v-col cols="12">
                <label> لیست شهرها : </label>
                <strong v-for="city in cityName" :key="city">
                  {{ city }} ،
                </strong>
              </v-col>
            </div>
          </v-col>
          <v-col cols="12" v-else>
            <v-col cols="12" md="4">
              <v-select
                v-model="limitation"
                :items="tradeRequestOrigin"
                item-text="displayName"
                item-value="title"
                persistent-hint
                clearable
                hide-details
                dense
                outlined
                label="نوع محدودیت"
              ></v-select>
            </v-col>
            <v-col cols="12" md="4" v-if="limitation && limitation.length">
              <v-autocomplete
                :items="statesList"
                multiple
                dense
                label="انتخاب استان"
                small-chips
                deletable-chips
                outlined
                item-text="value"
                item-value="id"
                v-model="stateIds"
                :placeholder="`لیست استان های های مورد نظر خود را انتخاب کنید`"
              >
              </v-autocomplete>
            </v-col>
            <v-col
              cols="12"
              md="4"
              v-if="limitation && limitation == 'City'"
              class="mt-n4"
            >
              <div dir="rtl">
                <strong>
                  {{
                    stateIds && stateIds.length
                      ? 'انتخاب شهر'
                      : 'ابتدا استان های مربوطه را انتخاب کنید'
                  }}
                </strong>
                <treeselect
                  appendToBody
                  required
                  :flatten-search-results="true"
                  :disable-branch-nodes="true"
                  :show-count="true"
                  :options="citiesList"
                  placeholder="لیست شهرهای های مورد نظر خود را انتخاب کنید"
                  v-model="limitationIds"
                  :normalizer="normalizerCityList"
                  outlined
                  :multiple="true"
                  dense
                  item-text="stateCityName"
                  item-value="id"
                />
              </div>
            </v-col>
          </v-col>
          <v-col cols="12" class="text-right float-right">
            <v-btn
              class="mx-1"
              small
              v-if="
                (tradeRequestItem.limitation != null &&
                  !limitationEditMode &&
                  tradeRequestItem.requestStatus == 'Draft') ||
                tradeRequestItem.requestStatus == 'Rejected'
              "
              color="error"
              @click="deleteLimitation()"
              >حذف محدودیت</v-btn
            >
            <v-btn
              v-else-if="
                tradeRequestItem.requestStatus == 'Draft' ||
                tradeRequestItem.requestStatus == 'Rejected'
              "
              class="mx-1"
              small
              color="error"
              @click="limitationEditMode = false"
            >
              انصراف</v-btn
            >
            <v-btn
              v-if="
                !limitationEditMode &&
                (tradeRequestItem.requestStatus == 'Draft' ||
                  tradeRequestItem.requestStatus == 'Rejected')
              "
              class="mx-1"
              small
              color="primary"
              @click="editLimitation()"
              >ویرایش محدودیت</v-btn
            >

            <v-btn
              v-else-if="
                tradeRequestItem.requestStatus == 'Draft' ||
                tradeRequestItem.requestStatus == 'Rejected'
              "
              class="mx-1"
              small
              color="primary"
              @click="saveLimitation()"
            >
              ثبت</v-btn
            >
          </v-col>
        </v-row>
      </v-sheet>
      <!-- <v-sheet outlined class="pa-1 pa-6 mt-5"> -->
      <v-row class="mt-5">
        <strong class="blue--text mr-2">مشاهده اقلام:</strong>

        <v-col cols="12">
          <trade-request-items
            :request="tradeRequestItem.request"
            :tradeRequestItems="tableItems"
            @getDataById="getDataById"
          />
        </v-col>
      </v-row>
      <!-- </v-sheet> -->
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="mx-2" color="error" @click="closeForm">بستن</v-btn>
      <v-btn
        class="mx-2"
        color="primary"
        @click="navToEdit"
        v-if="
          tradeRequestItem.requestStatus == 'Draft' ||
          tradeRequestItem.requestStatus == 'Rejected'
        "
        >ویرایش</v-btn
      >
      <v-btn
        class="mx-2"
        color="success"
        @click="requestConfirm()"
        v-if="
          tradeRequestItem.requestStatus == 'Rejected'
        "
        >تایید و ارسال</v-btn
      >
      <v-btn
        class="mx-2"
        color="success"
        @click="sendForSubmit"
        v-if="
          tradeRequestItem.requestStatus == 'Draft'
        "
        >بررسی جهت تایید</v-btn
      >
    </v-card-actions>
  </div>
</template>

<script>
import asyncLoadMixin from '@/core/mixins/asyncLoadMixin';
import reusableMethodsMixin from '@/core/mixins/reusableMethodsMixin';
import Helper from '@/core/helpers';
const merchantRepository = () => RepoFactory.get('merchant');
import { RepoFactory } from '@/baseRepository/Factory';
const tradeRequestRepository = () => RepoFactory.get('tradeRequests');
const enumsRepository = () => RepoFactory.get('enums');
import TradeRequestItems from './TradeRequestItems.vue';
import qs from 'qs';
import TradeRequestEvents from './TradeRequestEvents.vue';
const pagesRepository = () => RepoFactory.get('pages');

export default {
  components: { TradeRequestItems, TradeRequestEvents },
  mounted() {
    this.id = this.$route.params.id;
    this.getPageData();
    this.$store.commit('setTradeRequestSelectedForEdit', null);
    this.$store.commit('setTradeRequestIsEdit', false);
    this.$store.commit('setTradeRequestFormStatus', true);
    this.$store.commit('setTradeRequestShowDetailForm', true);
    this.getDataById();
    this.tradeCategories();
    this.tradeRequestType();
    this.tradePaymentMethod();
    this.tradeGuaranteeMethod();
  },
  mixins: [asyncLoadMixin, reusableMethodsMixin],

  data() {
    return {
      confimRequest: true,
      title: '',
      body: '',
      id: null,
      tradePaymentMethodList: [],
      deliveryDurationTypeList: [],
      rawMaterialSupplyTypesList: [],
      deliveryLocationList: [],
      tradeCategoriesList: [],
      tradeRequestTypeList: [],
      tradeRequestItem: [],
      tableItems: [],
      stateIds: [],
      stateName: [],
      cityName: [],
      tradeRequestOrigin: [],
      statesList: [],
      citiesList: [],
      limitation: null,
      limitationIds: null,
      limitationEditMode: false,
    };
  },

  watch: {
    limitation(after, before) {
      if ((after == 'City' || after == 'State') && before == null) {
        this.getStates();
      }
    },
    stateIds() {
      if (this.limitation == 'City' && this.stateIds.length) {
        this.getCitiesByStateIds();
      } else if (this.limitation == 'State' && this.stateIds.length) {
        this.limitationIds = this.stateIds;
      }
      if (this.stateIds == [] || this.stateIds == '' || this.stateIds == null) {
        this.citiesList = [];
        this.limitationIds = null;
      }
    },
  },

  computed: {
    contentBaseUrl() {
      return this.$store.getters.contentBaseUrl;
    },
    baseUrl() {
      return this.$store.getters.tradeBaseUrl;
    },
    merchantBaseUrl() {
      return this.$store.getters.merchantBaseUrl;
    },
  },
  methods: {
    sendForSubmit(){
      this.$router.push(`/trade-request-report/${this.$route.params.id}`)
    },
    tradeCategoryDisplayName(title) {
      if (this.tradeCategoriesList.length) {
        let result = this.tradeCategoriesList.find((el) => el.title == title);
        if (result) return result.displayName;
      }
    },
    tradeRequestDisplayName(title) {
      if (this.tradeRequestTypeList.length) {
        let result = this.tradeRequestTypeList.find((el) => el.title == title);
        if (result) return result.displayName;
      }
    },
    paymentMethodDisplayName(title) {
      if (this.tradePaymentMethodList.length) {
        let result = this.tradePaymentMethodList.find(
          (el) => el.title == title
        );
        if (result) return result.displayName;
      }
    },
    guaranteeMethodDisplayName(title) {
      if (this.tradeGuaranteeList.length) {
        let result = this.tradeGuaranteeList.find((el) => el.title == title);
        if (result) return result.displayName;
      }
    },
    tradeGuaranteeMethod() {
      this.tradeGuaranteeList = this.getEnumByTitle('GuaranteeType');
    },
    tradeCategories() {
      this.tradeCategoriesList = this.getEnumByTitle('CategoryTypeItems');
    },
    tradeRequestType() {
      this.tradeRequestTypeList = this.getEnumByTitle('TradeRequestType');
    },
    tradePaymentMethod() {
      this.tradePaymentMethodList = this.getEnumByTitle(
        'TradePaymentMethodType'
      );
    },
    DeliveryDurationType() {
      this.deliveryDurationTypeList = this.getEnumByTitle(
        'DeliveryDurationType'
      );
    },
    rawMaterialSupplyTypes() {
      this.rawMaterialSupplyTypesList = this.getEnumByTitle(
        'RawMaterialSupplyType'
      );
    },
    deliveryLocationItems() {
      this.deliveryLocationList = this.getEnumByTitle('DeliveryLocationType');
    },
    getDataById() {
      const loader = this.$loading.show();
      tradeRequestRepository()
        .getTradeRequestById(this.id, this.baseUrl)
        .then((res) => {
          this.tradeRequestItem = res.data;
          this.tableItems = this.tradeRequestItem.items;
          this.$store.commit('setTradeRequestSelectedForDisplay', res.data);
          this.getTradeLimitation();

          loader.hide();
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
          loader.hide();
        })
        .finally(() => loader.hide());
    },
    closeForm() {
      this.$store.commit('setTradeRequestIsEdit', false);
      this.$store.commit('setTradeRequestShowDetailForm', false);
      this.$store.commit('setTradeRequestSelectedForEdit', null);
      this.$store.commit('setTradeRequestFormStatus', false);
      this.$router.push({ path: '/trade-request' });
    },
    navToEdit() {
      this.$store.commit('setTradeRequestIsEdit', true);
      this.$router.push({ path: `/trade-request-edit/${this.id}` });
    },
    getPageData() {
      let params = {
        uniquePageName: this.$store.getters.uniqPageSendOrderToAdmin,
      };
      const loader = this.$loading.show();
      pagesRepository()
        .getUniquePage(this.contentBaseUrl, {}, params)
        .then(({ data }) => {
          this.title = data.title;
          this.body = data.body;
          loader.hide();
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
          loader.hide();
        });
    },
    requestConfirm() {
      let app = this;
      const loader = this.$loading.show();
      tradeRequestRepository()
        .sendConfirmRequest(this.id, this.baseUrl)
        .then((res) => {
          this.confimRequest = false;
          app.$dialog.info({
            text: this.body,
            title: this.title,
            persistent: true,
            actions: [
              {
                text: 'بستن',
                color: 'red',
              },
            ],
          });

          this.getData();
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
        })
        .finally(() => {
          loader.hide();
        });
    },
    getTradeLimitation() {
      if (this.tradeRequestItem.limitation == 'State') {
        this.limitation = 'State';
        this.limit = true;
        this.getStates();
        this.tradeRequestItem.limitationsDtos.forEach((x) => {
          this.stateIds.push(x.id);
          this.stateName.push(x.value);
        });
      } else if (this.tradeRequestItem.limitation == 'City') {
        this.limitation = 'City';
        this.limitationIds = [];
        this.limit = true;
        this.getStates();
        this.tradeRequestItem.limitationsDtos.forEach((x) => {
          this.limitationIds.push(x.id);
          this.cityName.push(x.value);
          this.stateIds.push(x.stateId);
          this.stateName.push(x.stateName);
        });
        this.cityName = Array.from(new Set(this.cityName));
        this.limitationIds = Array.from(new Set(this.limitationIds));
        this.stateIds = Array.from(new Set(this.stateIds));
        this.stateName = Array.from(new Set(this.stateName));
      }
    },
    getStates() {
      merchantRepository()
        .getProvince(this.merchantBaseUrl)
        .then((res) => {
          this.statesList = res.data;
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        });
    },
    getCitiesByStateIds() {
      let params = {
        stateIds: this.stateIds,
      };
      merchantRepository()
        .getCitiesOfMultipleStatesTree(
          this.merchantBaseUrl,
          params,
          {},
          (params) => {
            return qs.stringify(params, { arrayFormat: 'repeat' });
          }
        )
        .then((res) => {
          this.citiesList = res.data;
        });
    },
    deleteLimitation() {
      const loader = this.$loading.show();
      tradeRequestRepository()
        .deleteTradeRequestLimitation(this.id, this.baseUrl)
        .then((res) => {
          this.$dialog.message.success(' محدودیت مکانی با موفقیت حذف شد. ', {
            position: 'top-left',
          });
          this.getDataById();
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
        })
        .finally(() => loader.hide());
    },
    editLimitation() {
      this.limitationEditMode = true;
      this.getLimitationEnum();
      this.limitationIds = this.tradeRequestItem.limitationIds;
      this.getTradeLimitation();
    },
    getLimitationEnum() {
      enumsRepository()
        .getEnum('TradeRequestLimitationType', this.baseUrl)
        .then((res) => {
          this.tradeRequestOrigin = res.data.filter((x) => {
            if (x.title != 'Country') return x;
          });
        })
        .catch((err) => Helper.handleErrors(err, this));
    },
    saveLimitation() {
      const loader = this.$loading.show();
      let body = {
        limitation: this.limitation,
        limitationIds: this.limitationIds,
      };
      tradeRequestRepository()
        .editTradeRequestLimitation(this.id, body, this.baseUrl)
        .then((res) => {
          this.$dialog.message.success(' محدودیت مکانی با موفقیت ویرایش شد. ', {
            position: 'top-left',
          });
          this.limitationEditMode = false;
          this.limitationIds = [];
          this.cityName = [];
          this.stateIds = [];
          this.stateName = [];
          this.getDataById();
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
        })
        .finally(() => loader.hide());
    },
    normalizerCityList(content) {
      let object = {
        isDisabled: content.disabled,
        id: content.id,
        label: content.value,
      };
      if (content.cityList && content.cityList.length) {
        object.children = content.cityList;
      } else {
        delete content.cityList;
      }

      return object;
    },
  },
};
</script>

<style></style>
